const data = {
  id: 1,
  title: 'Choose one word whose underlined part is pronounced differently.',
  subTitle: 'Chọn từ có phần gạch chân phát âm khác các từ còn lại.',
  question: '',
  answers: [
    { id: 1, answer: 'ear<s>', isCorrect: true },
    { id: 2, answer: 'eye<s>', isCorrect: false },
    { id: 3, answer: 'lip<s>', isCorrect: false },
  ],
};

export default data;
